module.exports = __webpack_public_path__ + "img/content1.d0581576.png";